import { Box } from "@mui/material";
import AdminTable from "../../components/adminTable";

export default function AccontsTrip() {
  return (
    <>
      <Box mt="5px">
        <AdminTable selected={4} />
      </Box>
    </>
  );
}
